import { FunctionComponent, useEffect, useRef, useState } from "react";

import { Button, Card, Flex, Modal, Text, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Link } from "@chakra-ui/react";
import { getQueryClient } from "am-tax-fe-core";

import { getTosStatus, queryKeys, setTermsOfServiceAccepted, useCurrentUser } from "../api";

const TermsOfService: FunctionComponent = () => {
    const initialTitleRef = useRef<HTMLInputElement | null>(null);
    const [showTermsOfServiceDialog, setShowTermsOfServiceDialog] = useState(false);

    const currentUserQuery = useCurrentUser();
    const { data: currentUser } = currentUserQuery;

    const getTosStatusAsync = async () => {
        const tos = await getQueryClient().fetchQuery({ ...queryKeys.users.termsOfService, queryFn: async () => await getTosStatus() });
        setShowTermsOfServiceDialog(!tos.isAccepted);
    };

    useEffect(() => {
        if (currentUser && !currentUser.isInternal) {
            getTosStatusAsync();
        }
    }, [currentUser]);

    const handleClose = () => {
        return;
    };

    const handleOnAcceptTosBtnClick = async () => {
        setShowTermsOfServiceDialog(false);
        await setTermsOfServiceAccepted();
        await getQueryClient().invalidateQueries(queryKeys.users.termsOfService);
    };

    const tosDialog = (
        <Modal size="xl" initialFocusRef={initialTitleRef} finalFocusRef={initialTitleRef} isOpen={showTermsOfServiceDialog} onClose={handleClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Terms And Accepted Use</ModalHeader>
                <Card mx="1rem" p="1rem" backgroundColor="gray.100">
                    <Text>
                        Client's use of A&M Tax Engage Portal is subject to A&M TAX's{" "}
                        <Link target="_blank" variant="underline" href="https://www.alvarezandmarsal.com/terms-use" color="Blue">
                            Terms Of Use
                        </Link>
                        ,{" "}
                        <Link target="_blank" variant="underline" href="https://www.alvarezandmarsal.com/privacy-notice" color="Blue">
                            Privacy Notice
                        </Link>
                        ,{" "}
                        <Link target="_blank" variant="underline" href="https://www.alvarezandmarsal.com/privacy-notice-california" color="Blue">
                            California Privacy Notice
                        </Link>
                        {" and "}
                        <Link target="_blank" variant="underline" href="https://www.alvarezandmarsal.com/cookie-policy" color="Blue">
                            Cookie Policy
                        </Link>{" "}
                        and any other terms included on the Engage Portal website at{" "}
                        <Link target="_blank" variant="underline" href=" https://engage.alvarezandmarsaltax.com" color="Blue">
                            engage.alvarezandmarsaltax.com
                        </Link>{" "}
                        (the "Engage Terms"). Client agrees to comply at all times with the Engage Terms.
                    </Text>
                </Card>

                <ModalFooter px="1rem">
                    <Flex width="100%" justify="flex-end" align="center">
                        <Button colorScheme="blue" onClick={handleOnAcceptTosBtnClick}>
                            Accept
                        </Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );

    return showTermsOfServiceDialog ? tosDialog : null;
};

export default TermsOfService;
